import useMediaQuery from "@mui/material/useMediaQuery";
import Dialog from "@mui/material/Dialog";
import Drawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

export default function ZoomScheduleModal({
  open,
  onClose,
  name,
  setName,
  email,
  setEmail,
  date,
  setDate,
  time,
  handleTimeChange,
  confirmSchedule,
}) {
  const isMobile = useMediaQuery("(max-width:600px)");

  const Content = (
    <Box sx={{ p: { xs: 2, sm: 3 } }}>
      {/* Header */}
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", py: 1.5, pb: 3 }}>
            <img
                src="/images/zoom_icon.png"
                alt="Schedule a Zoom Call with Us"
                style={{ width: "100px", height: "auto" }} // fixed icon size works better on mobile
            />
        </Box>

      {/* Form */}
      <Stack sx={{ width: "100%", display: "flex", flexDirection: "column", gap: 2 }}>
        <TextField
          label="Full Name"
          variant="outlined"
          fullWidth
          value={name}
          onChange={(e) => setName(e.target.value)}
        />

        <TextField
          label="Email Address"
          variant="outlined"
          fullWidth
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label="Select Date"
            value={date}
            onChange={(newValue) => setDate(newValue)}
            slotProps={{ textField: { fullWidth: true, size: "medium" } }}
          />
        </LocalizationProvider>

        <Stack sx={{ gap: 1 }}>
          <Typography sx={{ fontWeight: 700, opacity: 0.7 }}>Select Time</Typography>

          <ToggleButtonGroup
            value={time}
            exclusive
            onChange={handleTimeChange}
            aria-label="Select Time"
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", sm: "repeat(3, 1fr)" },
              gap: 1.2,
              "& .MuiToggleButtonGroup-grouped": {
                margin: 0,
                border: "1px solid rgba(0,0,0,0.2)",
                borderRadius: "12px !important",
              },
              "& .MuiToggleButtonGroup-grouped:not(:first-of-type)": {
                borderLeft: "1px solid rgba(0,0,0,0.2)",
              },
            }}
          >
            <ToggleButton value="02:00PM" sx={{ textTransform: "none", fontWeight: 800 }}>
              02:00PM
            </ToggleButton>
            <ToggleButton value="06:00PM" sx={{ textTransform: "none", fontWeight: 800 }}>
              06:00PM
            </ToggleButton>
            <ToggleButton value="08:00PM" sx={{ textTransform: "none", fontWeight: 800 }}>
              08:00PM
            </ToggleButton>
          </ToggleButtonGroup>
        </Stack>

        <Button
          variant="contained"
          onClick={confirmSchedule}
          fullWidth
          sx={{ py: 1.2, borderRadius: 999, mt: 0.5 }}
        >
          Confirm Schedule
        </Button>
      </Stack>
    </Box>
  );

  // ✅ Mobile: Bottom sheet
  if (isMobile) {
    return (
      <Drawer
        anchor="bottom"
        open={open}
        onClose={onClose}
        PaperProps={{
          sx: {
            borderTopLeftRadius: 18,
            borderTopRightRadius: 18,
            maxHeight: "92vh",
          },
        }}
      >
        {/* little handle */}
        <Box sx={{ display: "flex", justifyContent: "center", pt: 1 }}>
          <Box sx={{ width: 48, height: 5, borderRadius: 999, bgcolor: "rgba(0,0,0,0.2)" }} />
        </Box>

        <Box sx={{ overflowY: "auto" }}>{Content}</Box>
      </Drawer>
    );
  }

  // ✅ Desktop: Center modal
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: 3,
          maxHeight: "85vh",
        },
      }}
    >
      <Box sx={{ overflowY: "auto" }}>{Content}</Box>
    </Dialog>
  );
}